import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import type { CSSProperties, ReactNode } from 'react';
import Chip, { type ChipTone } from '../../components/Chip';
import StammIcon, { type StammIconName } from '../stammdaten/StammIcon';
import { classColor } from './graphModel';

const ICONS: Readonly<Record<string, StammIconName>> = {
  ProduktType: 'box', ProduktVersion: 'layers', KomponenteType: 'component',
  KomponenteVersion: 'layers', ProduktVersionKomponente: 'link', Kunde: 'users',
  ProduktInstanz: 'box', CVE: 'shield',
  VulnerabilityEvent: 'shield', Benachrichtigung: 'bell', NotificationInstance: 'link',
};

export function EntityIcon({ klass, className = '' }: { klass: string; className?: string }): ReactNode {
  return <span className={`explorer-entity-icon ${className}`} style={{ '--entity-color': classColor(klass) } as CSSProperties}>
    <StammIcon name={ICONS[klass] ?? 'database'} />
  </span>;
}

export function ViewIcon({ name }: { name: 'relations' | 'graph' | 'orbit' }): ReactNode {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {name === 'relations' ? <><rect x="2" y="7" width="6" height="10" rx="2" /><rect x="16" y="7" width="6" height="10" rx="2" /><path d="M8 12h8m-5-3 3 3-3 3" /></> : name === 'graph' ? <><rect x="2" y="9" width="6" height="6" rx="1.5" /><rect x="16" y="2" width="6" height="6" rx="1.5" /><rect x="16" y="16" width="6" height="6" rx="1.5" /><path d="M8 12h4V5h4m-4 7v7h4" /></> : <><circle cx="12" cy="12" r="3" /><ellipse cx="12" cy="12" rx="11" ry="6" transform="rotate(-35 12 12)" /><circle cx="19.5" cy="6.5" r="2" fill="var(--panel)" /></>}
  </svg>;
}

const STATES: Readonly<Record<string, { label: MessageDescriptor; tone: ChipTone }>> = {
  danger: { label: msg`Kritisch`, tone: 'alert' },
  warn: { label: msg`Zu prüfen`, tone: 'warn' },
  ok: { label: msg`Unkritisch`, tone: 'good' },
};

export function NodeState({ state }: { state: string }): ReactNode {
  const { i18n } = useLingui();
  const entry = STATES[state];
  return entry ? <Chip tone={entry.tone}>{i18n._(entry.label)}</Chip> : null;
}
